import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const NAV_ITEMS = [
    { to: '/', label: 'Главная', end: true },
    { to: '/about', label: 'О компании' },
    { to: '/vacancies', label: 'Вакансии' },
    { to: '/conditions', label: 'Условия' },
    { to: '/faq', label: 'FAQ' },
    { to: '/contacts', label: 'Контакты' }
];

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="site-header">
            <div className="container site-header-inner">
                <Link to="/" className="site-logo" onClick={closeMenu}>
                    Работа в охране
                </Link>

                <nav className={`site-nav${menuOpen ? ' is-open' : ''}`}>
                    {NAV_ITEMS.map(({ to, label, end }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={end}
                            className={({ isActive }) =>
                                `site-nav-link${isActive ? ' is-active' : ''}`
                            }
                            onClick={closeMenu}
                        >
                            {label}
                        </NavLink>
                    ))}
                </nav>

                <div className="site-header-actions">
                    <button
                        type="button"
                        className={`site-nav-toggle${menuOpen ? ' is-open' : ''}`}
                        aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
